import {makeStyles as legacyMakeStyles} from '@yandex-taxi/go-web-components'

/** @deprecated */
const makeStyles = legacyMakeStyles

export default makeStyles
